import { MIN_WIDTH_LG, MIN_WIDTH_MD, MIN_WIDTH_XL } from '@SBGSports/referee-design-tokens';
import * as React from 'react';
import { ScreenClassProvider, ScreenClassProviderProps, setConfiguration } from 'react-grid-system';

setConfiguration({
    breakpoints: [1, MIN_WIDTH_MD, MIN_WIDTH_LG, MIN_WIDTH_XL, Infinity, Infinity],
    maxScreenClass: 'xl',
    gutterWidth: 16,
    containerWidths: [undefined, undefined, undefined, 1272],
});

export type GridProviderProps = ScreenClassProviderProps;

export const GridProvider: React.FunctionComponent<GridProviderProps> = (props) => {
    const { children, ...rest } = props;
    return <ScreenClassProvider {...rest}>{children}</ScreenClassProvider>;
};
